import { types, actions } from './requests'
export const SENDNOTIFICATION_TYPES = {
    ...types('SENDNOTIFICATION'),
}
export const SENDNOTIFICATION_ACTIONS = {
    ...actions('SENDNOTIFICATION'),
}
